export class NotificationMap {
  public PUSH_NOTIFICATION: boolean = false;
  public SMS: boolean = false;
  public EMAIL: boolean = false;
  public MARKETING_EMAIL: boolean = false;
  public VOICE: boolean = false;
  public WHATSAPP: boolean = false;
}

export class NotificationPreferences {
  public push: boolean = false;
  public sms: boolean = false;
  public email: boolean = false;
  public marketing: boolean = false;
  public voice: boolean = false;
  public whatsapp: boolean = false;
  public doNotTriggerEvent: boolean = false;
}
